import React from 'react'

const RunningIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="runningGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 160, 80, 1)" />
          <stop offset="100%" stopColor="rgba(220, 120, 60, 1)" />
        </linearGradient>
        <filter id="runningGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Head */}
      <circle 
        cx="13" 
        cy="4" 
        r="2"
        fill="url(#runningGradient)"
        filter="url(#runningGlow)"
      />
      
      {/* Body and limbs in running pose */}
      <path 
        d="M13 7l-2 5-3 1M13 7l2 3 3-1M11 12l-2 6-3 2M11 12l1 5 4 3"
        stroke="url(#runningGradient)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
        filter="url(#runningGlow)"
      />
      
      {/* Motion lines */}
      <path 
        d="M2 10h3M3 14h2M1 18h3"
        stroke="url(#runningGradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
        opacity="0.6"
      />
    </svg>
  )
}

export default RunningIcon
